import ConsoleApi from "@/consoleapi/consoleApi";
import {AxiosResponse} from "axios";

/**
 *
 */
export default class RestcommLogs extends ConsoleApi {
    protected resource = '/restcomm/logs';

    /**
     * @param accountId
     * @param page
     */
    public getCalls(accountId: string, page = 0): Promise<AxiosResponse> {
        const pageQuery = page > 0 ? "?page=" + String(page) : "";
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/calls' + pageQuery, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     * @param accountId
     * @param page
     */
    public getRecordings(accountId: string, page = 0): Promise<AxiosResponse> {
        const pageQuery = page > 0 ? "?page=" + String(page) : "";
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/recordings' + pageQuery, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }

    /**
     *
     * @param accountId
     * @param page
     */
    public getNotifications(accountId: string, page = 0): Promise<AxiosResponse> {
        const pageQuery = page > 0 ? "?page=" + String(page) : "";
        return this.axios.get(this.requestUri + this.getAccountResource(accountId) + '/notifications' + pageQuery, {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            }
        });
    }
}